const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error('App bootstrap timed out')), 15_000));

(async () => {
  try {
    await Promise.race([import('./bootstrap'), timeout]);
  } catch {
    document.getElementById('root')!.innerHTML =
      '<p style="color:white;padding:2rem;font-family:sans-serif">App failed to load. Please try refreshing the page.</p>';
  }
})();
